<section class="site-section" *ngIf="!loading">
  <div class="container bg-light">
    <div class="row">
      <div class="d-flex justify-content-start">
        
      </div>
    </div>
    <div class="row mb-5">
      <div class="col-12" data-aos="fade-up" data-aos-delay="100">
        <div class="form-group row">
          <div class="col-12 text-center">
            <h6 class="text-secondary">
              {{ "INVESTMENT IN MEXICAN PESOS CURRENCY"  }}
              <br>
              <br>
              {{ "(Modify the following data to calculate your profits)"  }}
            </h6>
            <hr />
          </div>
          <div class="col-md-4">
            <label class="col-form-label text-secondary">
              {{ "PLANTS NUMBER"  }}
            </label>
            <div class="input-group">
              <span class="input-group-prepend">
                <button
                  type="button"
                  class="btn btn-greenblue"
                  (click)="subtract(noPlantas, 'noPlantas')"
                >
                  <span class="fa fa-minus"></span>
                </button>
              </span>
              <button type="button" class="btn btn-gray" disabled>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="20px"
                  height="20px"
                  viewBox="0 0 24 24"
                  version="1.1"
                  class="kt-svg-icon simuInp"
                >
                  <g
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <polygon points="0 0 24 0 24 24 0 24"></polygon>
                    <path
                      d="M1.4152146,4.84010415 C11.1782334,10.3362599 14.7076452,16.4493804 12.0034499,23.1794656 C5.02500006,22.0396582 1.4955883,15.9265377 1.4152146,4.84010415 Z"
                      fill="#000000"
                      opacity="0.3"
                    ></path>
                    <path
                      d="M22.5950046,4.84010415 C12.8319858,10.3362599 9.30257403,16.4493804 12.0067693,23.1794656 C18.9852192,22.0396582 22.5146309,15.9265377 22.5950046,4.84010415 Z"
                      fill="#000000"
                      opacity="0.3"
                    ></path>
                    <path
                      d="M12.0002081,2 C6.29326368,11.6413199 6.29326368,18.7001435 12.0002081,23.1764706 C17.4738192,18.7001435 17.4738192,11.6413199 12.0002081,2 Z"
                      fill="#000000"
                      opacity="0.3"
                    ></path>
                  </g>
                </svg>
              </button>

              <input
                (keyup)="inputChange($event)"
                type="number"
                class="form-control input-number"
                name="noPlantas"
                [value]="noPlantas"
              />
              <span class="input-group-append">
                <button
                  type="button"
                  class="btn btn-greenblue"
                  (click)="add(noPlantas, 'noPlantas')"
                >
                  <span class="fa fa-plus"></span>
                </button>
              </span>
            </div>
          </div>
          <div class="col-md-4">
            <label class="col-form-label text-secondary">
              {{ "PLANT PRICE"  }}
            </label>
            <div class="input-group">
              <span class="input-group-prepend">
                <button
                  type="button"
                  class="btn btn-greenblue"
                  (click)="subtract(precioPlanta, 'precioPlanta')"
                >
                  <span class="fa fa-minus"></span>
                </button>
              </span>
              <button type="button" class="btn btn-gray" disabled>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="20px"
                  height="20px"
                  viewBox="0 0 24 24"
                  version="1.1"
                  class="kt-svg-icon simuInp"
                >
                  <g
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <rect x="0" y="0" width="24" height="24"></rect>
                    <rect
                      fill="#000000"
                      opacity="0.3"
                      x="11.5"
                      y="2"
                      width="2"
                      height="4"
                      rx="1"
                    ></rect>
                    <rect
                      fill="#000000"
                      opacity="0.3"
                      x="11.5"
                      y="16"
                      width="2"
                      height="5"
                      rx="1"
                    ></rect>
                    <path
                      d="M15.493,8.044 C15.2143319,7.68933156 14.8501689,7.40750104 14.4005,7.1985 C13.9508311,6.98949895 13.5170021,6.885 13.099,6.885 C12.8836656,6.885 12.6651678,6.90399981 12.4435,6.942 C12.2218322,6.98000019 12.0223342,7.05283279 11.845,7.1605 C11.6676658,7.2681672 11.5188339,7.40749914 11.3985,7.5785 C11.2781661,7.74950085 11.218,7.96799867 11.218,8.234 C11.218,8.46200114 11.2654995,8.65199924 11.3605,8.804 C11.4555005,8.95600076 11.5948324,9.08899943 11.7785,9.203 C11.9621676,9.31700057 12.1806654,9.42149952 12.434,9.5165 C12.6873346,9.61150047 12.9723317,9.70966616 13.289,9.811 C13.7450023,9.96300076 14.2199975,10.1308324 14.714,10.3145 C15.2080025,10.4981676 15.6576646,10.7419985 16.063,11.046 C16.4683354,11.3500015 16.8039987,11.7268311 17.07,12.1765 C17.3360013,12.6261689 17.469,13.1866633 17.469,13.858 C17.469,14.6306705 17.3265014,15.2988305 17.0415,15.8625 C16.7564986,16.4261695 16.3733357,16.8916648 15.892,17.259 C15.4106643,17.6263352 14.8596698,17.8986658 14.239,18.076 C13.6183302,18.2533342 12.97867,18.342 12.32,18.342 C11.3573285,18.342 10.4263378,18.1741683 9.527,17.8385 C8.62766217,17.5028317 7.88033631,17.0246698 7.285,16.404 L9.413,14.238 C9.74233498,14.6433354 10.176164,14.9821653 10.7145,15.2545 C11.252836,15.5268347 11.7879973,15.663 12.32,15.663 C12.5606679,15.663 12.7949989,15.6376669 13.023,15.587 C13.2510011,15.5363331 13.4504991,15.4540006 13.6215,15.34 C13.7925009,15.2259994 13.9286662,15.0740009 14.03,14.884 C14.1313338,14.693999 14.182,14.4660013 14.182,14.2 C14.182,13.9466654 14.1186673,13.7313342 13.992,13.554 C13.8653327,13.3766658 13.6848345,13.2151674 13.4505,13.0695 C13.2161655,12.9238326 12.9248351,12.7908339 12.5765,12.6705 C12.2281649,12.5501661 11.8323355,12.420334 11.389,12.281 C10.9583312,12.141666 10.5371687,11.9770009 10.1255,11.787 C9.71383127,11.596999 9.34650161,11.3531682 9.0235,11.0555 C8.70049838,10.7578318 8.44083431,10.3968355 8.2445,9.9725 C8.04816568,9.54816454 7.95,9.03200304 7.95,8.424 C7.95,7.67666293 8.10199848,7.03700266 8.406,6.505 C8.71000152,5.97299734 9.10899753,5.53600171 9.603,5.194 C10.0970025,4.85199829 10.6543302,4.60183412 11.275,4.4435 C11.8956698,4.28516587 12.5226635,4.206 13.156,4.206 C13.9160038,4.206 14.6918294,4.34533194 15.4835,4.624 C16.2751706,4.90266806 16.9686637,5.31433061 17.564,5.859 L15.493,8.044 Z"
                      fill="#000000"
                    ></path>
                  </g>
                </svg>
              </button>

              <input
                (keyup)="inputChange($event)"
                type="text"
                class="form-control input-number"
                name="precioPlanta"
                [value]="precioPlanta"
              />
              <span class="input-group-append">
                <button
                  type="button"
                  class="btn btn-greenblue"
                  (click)="add(precioPlanta, 'precioPlanta')"
                >
                  <span class="fa fa-plus"></span>
                </button>
              </span>
            </div>
          </div>
          <div class="col-md-4">
            <label class="col-form-label text-secondary">
              {{ "TOTAL INVESTED"  }}
            </label>
            <div class="input-group">
              <span class="input-group-prepend">
                <button
                  type="button"
                  class="btn btn-greenblue"
                  (click)="subtract(totalInvertido, 'totalInvertido')"
                >
                  <span class="fa fa-minus"></span>
                </button>
              </span>
              <button type="button" class="btn btn-gray" disabled>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="20px"
                  height="20px"
                  viewBox="0 0 24 24"
                  version="1.1"
                  class="kt-svg-icon simuInp"
                >
                  <g
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <rect x="0" y="0" width="24" height="24"></rect>
                    <rect
                      fill="#000000"
                      opacity="0.3"
                      x="11.5"
                      y="2"
                      width="2"
                      height="4"
                      rx="1"
                    ></rect>
                    <rect
                      fill="#000000"
                      opacity="0.3"
                      x="11.5"
                      y="16"
                      width="2"
                      height="5"
                      rx="1"
                    ></rect>
                    <path
                      d="M15.493,8.044 C15.2143319,7.68933156 14.8501689,7.40750104 14.4005,7.1985 C13.9508311,6.98949895 13.5170021,6.885 13.099,6.885 C12.8836656,6.885 12.6651678,6.90399981 12.4435,6.942 C12.2218322,6.98000019 12.0223342,7.05283279 11.845,7.1605 C11.6676658,7.2681672 11.5188339,7.40749914 11.3985,7.5785 C11.2781661,7.74950085 11.218,7.96799867 11.218,8.234 C11.218,8.46200114 11.2654995,8.65199924 11.3605,8.804 C11.4555005,8.95600076 11.5948324,9.08899943 11.7785,9.203 C11.9621676,9.31700057 12.1806654,9.42149952 12.434,9.5165 C12.6873346,9.61150047 12.9723317,9.70966616 13.289,9.811 C13.7450023,9.96300076 14.2199975,10.1308324 14.714,10.3145 C15.2080025,10.4981676 15.6576646,10.7419985 16.063,11.046 C16.4683354,11.3500015 16.8039987,11.7268311 17.07,12.1765 C17.3360013,12.6261689 17.469,13.1866633 17.469,13.858 C17.469,14.6306705 17.3265014,15.2988305 17.0415,15.8625 C16.7564986,16.4261695 16.3733357,16.8916648 15.892,17.259 C15.4106643,17.6263352 14.8596698,17.8986658 14.239,18.076 C13.6183302,18.2533342 12.97867,18.342 12.32,18.342 C11.3573285,18.342 10.4263378,18.1741683 9.527,17.8385 C8.62766217,17.5028317 7.88033631,17.0246698 7.285,16.404 L9.413,14.238 C9.74233498,14.6433354 10.176164,14.9821653 10.7145,15.2545 C11.252836,15.5268347 11.7879973,15.663 12.32,15.663 C12.5606679,15.663 12.7949989,15.6376669 13.023,15.587 C13.2510011,15.5363331 13.4504991,15.4540006 13.6215,15.34 C13.7925009,15.2259994 13.9286662,15.0740009 14.03,14.884 C14.1313338,14.693999 14.182,14.4660013 14.182,14.2 C14.182,13.9466654 14.1186673,13.7313342 13.992,13.554 C13.8653327,13.3766658 13.6848345,13.2151674 13.4505,13.0695 C13.2161655,12.9238326 12.9248351,12.7908339 12.5765,12.6705 C12.2281649,12.5501661 11.8323355,12.420334 11.389,12.281 C10.9583312,12.141666 10.5371687,11.9770009 10.1255,11.787 C9.71383127,11.596999 9.34650161,11.3531682 9.0235,11.0555 C8.70049838,10.7578318 8.44083431,10.3968355 8.2445,9.9725 C8.04816568,9.54816454 7.95,9.03200304 7.95,8.424 C7.95,7.67666293 8.10199848,7.03700266 8.406,6.505 C8.71000152,5.97299734 9.10899753,5.53600171 9.603,5.194 C10.0970025,4.85199829 10.6543302,4.60183412 11.275,4.4435 C11.8956698,4.28516587 12.5226635,4.206 13.156,4.206 C13.9160038,4.206 14.6918294,4.34533194 15.4835,4.624 C16.2751706,4.90266806 16.9686637,5.31433061 17.564,5.859 L15.493,8.044 Z"
                      fill="#000000"
                    ></path>
                  </g>
                </svg>
              </button>

              <input
                (keyup)="inputChange($event)"
                type="text"
                class="form-control input-number"
                name="totalInvertido"
                [value]="totalInvertido"
              />
              <span class="input-group-append">
                <button
                  type="button"
                  class="btn btn-greenblue"
                  (click)="add(totalInvertido, 'totalInvertido')"
                >
                  <span class="fa fa-plus"></span>
                </button>
              </span>
            </div>
          </div>
        </div>

        <!--TODO:PARTE2-->
        <div class="form-group row">
          <div class="col-12 text-center">
            
            <hr />
          </div>

          <div class="col-md-4">
            <label class="col-form-label text-secondary">
              {{ "PRICE FOR KILO" }}
            </label>
            <div class="input-group">
              <span class="input-group-prepend">
                <button
                  type="button"
                  class="btn btn-greenblue"
                  (click)="subtract(precioKilo, 'precioKilo')"
                >
                  <span class="fa fa-minus"></span>
                </button>
              </span>
              <button type="button" class="btn btn-gray" disabled>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="20px"
                  height="20px"
                  viewBox="0 0 24 24"
                  version="1.1"
                  class="kt-svg-icon simuInp"
                >
                  <g
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <polygon points="0 0 24 0 24 24 0 24"></polygon>
                    <path
                      d="M1.4152146,4.84010415 C11.1782334,10.3362599 14.7076452,16.4493804 12.0034499,23.1794656 C5.02500006,22.0396582 1.4955883,15.9265377 1.4152146,4.84010415 Z"
                      fill="#000000"
                      opacity="0.3"
                    ></path>
                    <path
                      d="M22.5950046,4.84010415 C12.8319858,10.3362599 9.30257403,16.4493804 12.0067693,23.1794656 C18.9852192,22.0396582 22.5146309,15.9265377 22.5950046,4.84010415 Z"
                      fill="#000000"
                      opacity="0.3"
                    ></path>
                    <path
                      d="M12.0002081,2 C6.29326368,11.6413199 6.29326368,18.7001435 12.0002081,23.1764706 C17.4738192,18.7001435 17.4738192,11.6413199 12.0002081,2 Z"
                      fill="#000000"
                      opacity="0.3"
                    ></path>
                  </g>
                </svg>
              </button>

              <input
                (keyup)="inputChange($event)"
                type="text"
                class="form-control input-number"
                name="precioKilo"
                [value]="precioKilo"
              />
              <span class="input-group-append">
                <button
                  type="button"
                  class="btn btn-greenblue"
                  (click)="add(precioKilo, 'precioKilo')"
                >
                  <span class="fa fa-plus"></span>
                </button>
              </span>
            </div>
          </div>
          <div class="col-md-4">
            <label class="col-form-label text-secondary">
              {{ "YEARS PLANTED"  }}
            </label>
            <div class="input-group">
              <span class="input-group-prepend">
                <button
                  type="button"
                  class="btn btn-greenblue"
                  (click)="subtract(aniosPlantada, 'aniosPlantada')"
                >
                  <span class="fa fa-minus"></span>
                </button>
              </span>
              <button type="button" class="btn btn-gray" disabled>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="20px"
                  height="20px"
                  viewBox="0 0 24 24"
                  version="1.1"
                  class="kt-svg-icon simuInp"
                >
                  <g
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <rect x="0" y="0" width="24" height="24"></rect>
                    <rect
                      fill="#000000"
                      opacity="0.3"
                      x="4"
                      y="4"
                      width="4"
                      height="4"
                      rx="2"
                    ></rect>
                    <rect
                      fill="#000000"
                      x="4"
                      y="10"
                      width="4"
                      height="4"
                      rx="2"
                    ></rect>
                    <rect
                      fill="#000000"
                      x="10"
                      y="4"
                      width="4"
                      height="4"
                      rx="2"
                    ></rect>
                    <rect
                      fill="#000000"
                      x="10"
                      y="10"
                      width="4"
                      height="4"
                      rx="2"
                    ></rect>
                    <rect
                      fill="#000000"
                      x="16"
                      y="4"
                      width="4"
                      height="4"
                      rx="2"
                    ></rect>
                    <rect
                      fill="#000000"
                      x="16"
                      y="10"
                      width="4"
                      height="4"
                      rx="2"
                    ></rect>
                    <rect
                      fill="#000000"
                      x="4"
                      y="16"
                      width="4"
                      height="4"
                      rx="2"
                    ></rect>
                    <rect
                      fill="#000000"
                      x="10"
                      y="16"
                      width="4"
                      height="4"
                      rx="2"
                    ></rect>
                    <rect
                      fill="#000000"
                      x="16"
                      y="16"
                      width="4"
                      height="4"
                      rx="2"
                    ></rect>
                  </g>
                </svg>
              </button>

              <input
                (keyup)="inputChange($event)"
                type="text"
                class="form-control input-number"
                name="aniosPlantada"
                [value]="aniosPlantada"
              />
              <span class="input-group-append">
                <button
                  type="button"
                  class="btn btn-greenblue"
                  (click)="add(aniosPlantada, 'aniosPlantada')"
                >
                  <span class="fa fa-plus"></span>
                </button>
              </span>
            </div>
          </div>
          <div class="col-md-4">
            <label class="col-form-label text-secondary">
              {{ "KILOS FOR PLANT" }}
            </label>
            <div class="input-group">
              <span class="input-group-prepend">
                <button
                  type="button"
                  class="btn btn-greenblue"
                  (click)="subtract(kilosPorPlanta, 'kilosPorPlanta')"
                >
                  <span class="fa fa-minus"></span>
                </button>
              </span>
              <button type="button" class="btn btn-gray" disabled>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="20px"
                  height="20px"
                  viewBox="0 0 24 24"
                  version="1.1"
                  class="kt-svg-icon simuInp"
                >
                  <g
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <polygon points="0 0 24 0 24 24 0 24"></polygon>
                    <path
                      d="M1.4152146,4.84010415 C11.1782334,10.3362599 14.7076452,16.4493804 12.0034499,23.1794656 C5.02500006,22.0396582 1.4955883,15.9265377 1.4152146,4.84010415 Z"
                      fill="#000000"
                      opacity="0.3"
                    ></path>
                    <path
                      d="M22.5950046,4.84010415 C12.8319858,10.3362599 9.30257403,16.4493804 12.0067693,23.1794656 C18.9852192,22.0396582 22.5146309,15.9265377 22.5950046,4.84010415 Z"
                      fill="#000000"
                      opacity="0.3"
                    ></path>
                    <path
                      d="M12.0002081,2 C6.29326368,11.6413199 6.29326368,18.7001435 12.0002081,23.1764706 C17.4738192,18.7001435 17.4738192,11.6413199 12.0002081,2 Z"
                      fill="#000000"
                      opacity="0.3"
                    ></path>
                  </g>
                </svg>
              </button>

              <input
                (keyup)="inputChange($event)"
                type="text"
                class="form-control input-number"
                name="kilosPorPlanta"
                [value]="kilosPorPlanta"
              />
              <span class="input-group-append">
                <button
                  type="button"
                  class="btn btn-greenblue"
                  (click)="add(kilosPorPlanta, 'kilosPorPlanta')"
                >
                  <span class="fa fa-plus"></span>
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <h6 class="text-secondary">
      {{ "RESULTS"  }}
    </h6>

    <div class="row mb-5">
      <div class="col-12 table-responsive">
        <table class="table table-hover" width="100%" style="font-size: 18px">
          <tbody>
            <tr>
              <td style="font-size: 15px">
                <b> {{ "HECTARES:" }} </b>
                <span>{{ noPlantas / 3990 | number: "1.2-2" }}</span>
                <span style="font-size: 12px">
                  (3,990 {{ "PlantS"  }})</span
                ><br /><b>{{ "SOLARES: "  }}</b>
                <span class="amount">{{
                  noPlantas / 700 | number: "1.2-2"
                }}</span>
                <span style="font-size: 12px">
                  (700 {{ "Plants for Solar"  }})</span
                >
              </td>
              <td>
                <b
                  ><span>{{ "REAL PROFIT"  }}</span>
                  <span class="text-success">
                    {{ utilidadNeta | currency }}</span
                  ></b
                >
                <span style="font-size: 12px">
                  ({{ utilidadBruta | currency }} - 35%)</span
                >
              </td>
            </tr>
            <tr>
              <td>
                <b> {{ "TOTAL INVESTED"  }} </b>
                <span class="dinero">{{ totalInvertido | currency }}</span>
              </td>
              <td>
                <b>{{ "PLANT PROFIT" }}</b>
                <span> {{ utilidadNeta / noPlantas | currency }}</span>
              </td>
              <td></td>
            </tr>
            <tr>
              <td>
                <b
                  ><span>{{ "NOT REAL PROFIT"  }}</span>
                  <span class="text-success">
                    {{ utilidadBruta | currency }}</span
                  ></b
                >
              </td>
              <td>
                <b>{{ "DAY PROFIT"  }}</b>
                <span>
                  {{ utilidadNeta / (aniosPlantada * 365) | currency }}</span
                >
              </td>
              <td></td>
            </tr>
            <tr>
              <td>
                <b> {{ "MONTH PROFIT"  }} </b>
                <span>
                  {{
                    (utilidadMes * 100) / totalInvertido | number: "1.2-2"
                  }}</span
                >%
              </td>
              <td>
                <b>{{ "MONTH PROFIT" }}</b>
                <span> {{ utilidadMes | currency }}</span>
              </td>
              <td></td>
            </tr>
            <tr>
              <td>
                <b>{{ "YEAR PROFIT" }}</b>
                <span>
                  {{
                    (utilidadAnio * 100) / totalInvertido | number: "1.2-2"
                  }}</span
                >%
              </td>
              <td>
                <b>{{ "YEAR PROFIT"  }}</b>

                <span> {{ utilidadAnio | currency }}</span>
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</section>



